export enum CrdType {
    VirtualService = 'VirtualService',
    DestinationRule = 'DestinationRule',
    ServiceEntry = 'ServiceEntry',
}

export enum CrdManageType {
    CREATE = 'CREATE',
    UPDATE = 'UPDATE',
    VIEW = 'VIEW',
}
